export default {
  text: 'La mappa è fornita da Google. Il caricamento invia il tuo indirizzo IP a Google.',
  buttons: {
    show_map: 'Mostra mappa',
    retry: 'Riprova',
  },
  errors: {
    map_unavailable: 'Impossibile caricare la mappa.',
  },
};
